import { ProductNames } from "constants/forecasts.constants";

const forecastBackendProductToDisplayMapping: Record<string, string> = {
  shrinkage: ProductNames.Shrinkage,
  "sales gas": ProductNames.SalesGas,
  ethYieldSales: ProductNames.C2,
  propYieldSales: ProductNames.C3,
  butYieldSales: ProductNames.C4,
  "pent+YieldSales": ProductNames.C5,
  heatingValue: ProductNames.HV
};

const toExpectedDisplayName = (key: string): string => {
  return forecastBackendProductToDisplayMapping[key] || key;
};

const toExpectedForecastBackendProductName = (value: string): string => {
  const entry = Object.entries(forecastBackendProductToDisplayMapping).find(
    ([, v]) => v.toLowerCase() === value.toLowerCase()
  );
  return entry ? entry[0] : value;
};

const toExpectedTypeWellBackendProductName = (value: string): string => {
  return value;
};

const formatProductName = (product: string): string => {
  if (
    product === ProductNames.Condensate ||
    product === ProductNames.CondAbbreviatedWithDot
  ) {
    return ProductNames.CondAbbreviated;
  }
  if (product === ProductNames.C5) {
    return ProductNames.C5PlusGR;
  }
  if (
    [ProductNames.C2, ProductNames.C3, ProductNames.C4].includes(product as ProductNames)
  ) {
    return `${product}GR`;
  }
  return product;
};

export {
  toExpectedDisplayName,
  toExpectedForecastBackendProductName,
  toExpectedTypeWellBackendProductName,
  formatProductName
};
